import React, { useEffect, useState } from "react";
import moment from "moment";
import '../../../Assets/Css/TaskCalendar.scss';
import Select from 'react-select';
import CustomCalendar from '../../../Components/CustomCalendar';
import { customStyle } from '../../../Components/Style';
import { useLocation, useNavigate } from "react-router-dom";
import Drag_Drop from "../../../Assets/Images/Employee/Drag_Drop"
import Summery from "../../../Assets/Images/Employee/Summery"
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import { FaList } from "react-icons/fa";
import { BiCalendarStar } from "react-icons/bi";
import "../../../Assets/Css/Holiday.scss";
import { Calendar } from "antd";
import EventsListsList from "../../../Assets/Images/Attendance/EventsListsList";
import EventsListsCalendar from "../../../Assets/Images/Attendance/EventsListsCalendar";

moment.locale("en-GB");

const LeaveCalendar = (props) => {

    const [eventsData, setEventsData] = useState([]);
    const [activeButton, setActiveButton] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [calendarDate, setCalendarDate] = useState(new Date());

    const initialState = {
        leavetype: { value: "Casual", label: "Casual" },
        leavestatus: { value: "Approved", label: "Approved" }
    }

    const [clientData, setClientData] = useState(initialState);
    const [dateStatus, setDateStatus] = useState(false);
    const [filteredStartDate, setFilteredStartDate] = useState(null);
    const [filteredEndDate, setFilteredEndDate] = useState(null);

    useEffect(() => {
        const startOfMonth = moment().startOf('month').toDate();
        const endOfMonth = moment().endOf('month').toDate();

        setFilteredStartDate(startOfMonth);
        setFilteredEndDate(endOfMonth);
        setDateStatus(true);
    }, []);

    useEffect(() => {
        fetchData();
    }, [location.search]);

    const fetchData = async () => {
        try {
            await props?.getLeaves();
        } catch (error) {
            console.error("Error fetching leaves:", error);
        }
    };

    const LeaveType = [
        { value: "Casual", label: "Casual" },
        // { value: "Earned", label: "Earned" },
        { value: "Unpaid", label: "Unpaid" },
    ];

    const LeaveStatus = [
        { value: "Pending", label: "Pending" },
        { value: "Approved", label: "Approved" },
        { value: "Rejected", label: "Rejected" },
    ];


    let path = '/leave/empleave/add';
    const ClickAddLeave = () => {
        navigate(path);
    };

    const searchFiled = (e) => {
        const { name, value } = e.target;
        setClientData((preVal) => ({
            ...preVal,
            [name]: value,
        }));
    };

    useEffect(() => {
        if (props?.leave?.length) {
            updateCalendarData(props?.leave)
        }
    }, [props?.leave]);

    useEffect(() => {
        if (props?.leave?.length && filteredStartDate && filteredEndDate) {
            applyFilters({
                startDate: filteredStartDate,
                endDate: filteredEndDate,
                type: initialState.leavetype,
                status: initialState.leavestatus
            });
        }
    }, [props?.leave, filteredStartDate, filteredEndDate]);

    const updateCalendarData = (data) => {
        setLoading(true);
        setEventsData(
            data?.map((item) => ({
                id: item?.id,
                title: item?.user?.name,
                allDay: true,
                start: moment(item?.start_date, 'YYYY-MM-DD').startOf('day').toDate(),
                end: moment(item?.end_date, 'YYYY-MM-DD').endOf('day').toDate(),
                allData: {
                    ...item
                }
            }))
        );
        setLoading(false);
    }


    useEffect(() => {
        if (location.pathname === "/leave/empleave") {
            setActiveButton(location.pathname.slice(7))
        } else if (location.pathname === "/leave/empleave/empcalendar") {
            setActiveButton(location.pathname.slice(16))
        }
    }, []);

    const handleClickBtn = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
    };

    useEffect(() => {
        if (location.pathname == '/task') {
            const path = location.pathname.slice(1);
            setActiveButton(path);
        } else if (location.pathname == '/task/taskboard') {
            const path = location.pathname.slice(6);
            setActiveButton(path);
        } else if (location.pathname == '/task/taskcalendar') {
            const path = location.pathname.slice(6);
            setActiveButton(path);
        } else if (location.pathname == '/task/taskpinned') {
            const path = location.pathname.slice(6);
            setActiveButton(path);
        }
    }, []);

    const applyFilters = ({ startDate, endDate, type, status }) => {

        const currentStartDate = startDate || filteredStartDate;
        const currentEndDate = endDate || filteredEndDate;

        setFilteredStartDate(currentStartDate);
        setFilteredEndDate(currentEndDate);
        if (currentStartDate) {
            setCalendarDate(new Date(currentStartDate));
        }

        const data = props?.leave;
        const filtered = data?.filter((leave) => {
            let matchesStatus = true;
            let matchesDate = true;
            let matchesType = true;

            if (currentStartDate && currentEndDate) {
                setDateStatus(true);

                const itemStartDate = moment(leave?.start_date).startOf('day');
                const itemEndDate = moment(leave?.end_date).startOf('day');

                const filterStart = moment(currentStartDate).startOf('day');
                const filterEnd = moment(currentEndDate).endOf('day');

                matchesDate =
                    itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
                    itemEndDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
                    (itemStartDate.isSameOrBefore(filterEnd) && itemEndDate.isSameOrAfter(filterStart));
            }

            if (status) {
                matchesStatus = leave?.status?.toLowerCase() == status?.value?.toLowerCase();
            }

            if (type) {
                const leaveType = (leave?.casual > 0 && leave?.unpaid > 0) ? "Casual/Unpaid" :
                    leave?.unpaid > 0 ? "Unpaid" : "Casual";
                matchesType = leaveType?.toLowerCase() == type?.value?.toLowerCase();
            }

            return matchesStatus && matchesDate && matchesType;
        });
        updateCalendarData(filtered);
    };

    const handleClear = () => {
        setClientData({
            leavetype: null,
            leavestatus: null
        });
        setDateStatus(false);
        updateCalendarData(props?.leave);
        setFilteredStartDate(null);
        setFilteredEndDate(null);
        setCalendarDate(new Date());
    }

    const handleCalendarNavigate = (newDate) => {
        setCalendarDate(newDate);
    }

    const handleNavigate = (event) => {
        navigate(`/leave/empleave/view/${event.id}`, { state: { data: { allData: event }, from: location.pathname } })
    }

    const dateCellRender = (value) => {
        const date = value.format("YYYY-MM-DD");
        const events = eventsData.filter(event =>
            moment(date).isBetween(moment(event.start), moment(event.end), null, '[]')
        );

        return (
            <div className="holiday-events">
                {events.map((item) => (
                    <div
                        key={item.id}
                        className="holiday-marker"
                        role="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleNavigate(item.allData);
                        }}
                    >
                        {item.title}
                    </div>
                ))}
            </div>
        );
    };

    const onPanelChange = (value, mode) => {
        setCalendarDate(value.toDate());
    };

    return (
        <div className="task-calendar">
            <div className="taskcalendar-main">
                <div className="page-title">
                    <h4> Leaves Calendar </h4>
                    <div>
                        <button
                            className="custom-taskcalendar-btn"
                            disabled={props.loading}
                            onClick={ClickAddLeave}
                        >
                            {props.loading ? (
                                <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                            ) : (
                                'Add Leave'
                            )}
                        </button></div>
                </div>

                <div className="row">
                    <div className="col-lg-4">
                        <div className="input-group">
                            <CustomCalendar
                                inData={props?.leave}
                                applyFilters={(params) => { applyFilters(params) }}
                                startDate={filteredStartDate}
                                endDate={filteredEndDate}
                                setStartDate={setFilteredStartDate}
                                setEndDate={setFilteredEndDate}
                            />
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <div className="input-group">
                            <Select
                                options={LeaveType}
                                styles={{
                                    ...customStyle,
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 2,
                                    }),
                                }}
                                value={clientData?.leavetype}
                                placeholder="Leave Type"
                                onChange={(val) => {
                                    setClientData((preVal) => ({
                                        ...preVal,
                                        leavetype: val
                                    }));
                                    applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, type: val, status: clientData?.leavestatus })
                                }}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="input-group">
                            <Select
                                options={LeaveStatus}
                                styles={{
                                    ...customStyle,
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 2,
                                    }),
                                }}
                                value={clientData.leavestatus}
                                placeholder="Leave Status"
                                onChange={(val) => {
                                    setClientData((preVal) => ({
                                        ...preVal,
                                        leavestatus: val
                                    }));
                                    applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, type: clientData?.leavetype, status: val })
                                }}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-lg-1">
                        {(clientData?.leavestatus || clientData?.leavetype || dateStatus) && (
                            <button
                                className="export-btn"
                                disabled={props.loading}
                                onClick={handleClear}
                            >
                                {props.loading ? (
                                    <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                                ) : (
                                    'Clear'
                                )}
                            </button>
                        )}
                    </div>
                </div>

                <div className="gap-4 taskcalendar-export-btn">
                    <div>
                    </div>

                    <div className="navigation_btn" style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <button
                            className={`btn1 ${activeButton === "empleave" ? "active" : ""}`}
                            onClick={() => handleClickBtn("empleave", "/leave/empleave")}
                        >
                            <EventsListsList
                                color={!activeButton ? "white" : "black"}
                                bgColor={!activeButton ? "black" : "white"}
                            />
                        </button>
                        <button
                            className={`btn1 ${activeButton === "empcalendar" ? "active" : ""}`}
                            onClick={() => handleClickBtn("empcalendar", "/leave/empleave/empcalendar")}
                        >
                            <EventsListsCalendar
                                color={activeButton ? "white" : "black"}
                                bgColor={activeButton ? "black" : "white"}
                            />
                        </button>
                    </div>
                </div>
            </div>

            <div className="holiday-calendar">
                <Calendar
                    mode="month"
                    dateCellRender={dateCellRender}
                    onPanelChange={onPanelChange}
                    views={["day", "agenda", "work_week", "month"]}
                    selectable
                    localizer={localizer}
                    date={calendarDate}
                    defaultView="month"
                    events={eventsData}
                    style={{ height: "100vh" }}
                    onSelectEvent={(event) => handleNavigate(event)}
                    onNavigate={handleCalendarNavigate}
                />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        loading: state?.leaveReducer?.loading,
        leave: state?.leaveReducer?.leave,
        user: state?.authenticationReducer?.user
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getLeaves: () => {
            dispatch(getLeaves())
        },
        updateLeave: (id, data) => {
            dispatch(updateLeave(id, data))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaveCalendar);